import React from 'react';
import { ProductInventoryListTemplate } from 'themes/modules/product/pages';

class ProductInventoryList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<ProductInventoryListTemplate
				{...this.props}
				change={this.props.productDetailViewStore.change}
				actions={this.props.productDetailViewStore}
				showActions={this.props.productDetailViewStore.showActions}
			/>
		);
	}
}

export default ProductInventoryList;



// WEBPACK FOOTER //
// ./src/modules/product/pages/ProductInventoryList.jsx